// Please keep keys lowercase!
exports.supportedLanguages = {
  en: 'English',
  'zh-hans': '简体中文',
};
